import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto"; // eslint-disable-line no-unused-vars
import { Skeleton } from "@material-ui/lab";

const LineChart = (props) => {
    return (
        <div>
            {
                props.load ?
                    <Skeleton variant="rect" height={150} /> :
                    <Line data={props.data} />
            }
        </div>
    )
}

export default LineChart